import pearClient from 'apis/pearClient';
import { dateWithTimezone } from 'utils/dateTime';
import { getEventChangeDateTrackingValues } from 'utils/highcharts';

export interface IEvent {
  trigger: string;
  min: number;
  max: number;
  rangeSelectorButton: {
    text: string;
  };
}

const modulesChartConfig = (elementId: string, timezone: string) => ({
  lang: {
    noData: 'No data available',
  },
  time: {
    timezone,
  },
  chart: {
    renderTo: elementId,
    type: 'column',
    styledMode: true,
  },
  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  xAxis: {
    dateTimeLabelFormats: { day: '%b %d' },
    tickWidth: 0,
    events: {
      setExtremes: (event: IEvent) => {
        const tab = 'Lessons';
        const { button, from, to } = getEventChangeDateTrackingValues(
          event,
          timezone,
        );
        if (button) {
          pearClient.v2.tracking.trackDateRangeChangeEvent(
            tab,
            button,
            from,
            to,
          );
        }
      },
    },
  },
  yAxis: {
    title: {
      text: 'Lesson Use (min)',
      margin: 12,
    },
    labels: {
      x: -8,
      y: 4,
    },
    stackLabels: { enabled: false },
    opposite: false,
  },
  legend: { enabled: false },
  rangeSelector: {
    enabled: false,
  },
  noData: {
    style: {
      fontSize: '18px',
      fontWeight: 'normal',
      color: '#cccccc',
    },
  },
  navigator: {
    enabled: false,
  },
  scrollbar: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    formatter: function formatter() {
      // @ts-ignore
      const formattedDate: string = dateWithTimezone(timezone, this.x).format(
        'dddd, MMMM D, YYYY',
      );
      const lines = [];
      lines.push(`<b>${formattedDate}</b>`);
      // @ts-ignore
      this.points.forEach((point) => {
        const formattedY = point.y.toFixed(2);
        lines.push(`${point.series.name}: <b>${formattedY}</b>`);
      });
      return lines.join('<br/>');
    },
  },
});

export default modulesChartConfig;
